const linearProgressPalette = (tokens) => {
    return {
        height: tokens.linearSizeSMinHeight,
        fill: {
            border: {
                radius: tokens.linearFillRadius,
                width: tokens.linearFillBorderWidth,
                default: tokens.progressFillColorBorderDefault,
                error: tokens.progressFillColorBorderError
            },
            background: {
                default: tokens.progressFillColorBgDefault,
                error: tokens.progressFillColorBgError
            }
        },
        container: {
            border: {
                radius: tokens.linearContainerRadius,
                width: tokens.linearContainerBorderWidth,
                default: tokens.progressContainerColorBorder
            },
            background: {
                default: tokens.progressContainerColorBg
            }
        }
    };
};
export default linearProgressPalette;
//# sourceMappingURL=linearProgress.js.map